import toast, { ToastBar, Toaster as ReactToaster, Toast } from 'react-hot-toast';
import { Check, CircleNotch, Warning } from '@phosphor-icons/react';

export function Toaster() {
    const dismissToast = (t: Toast) => {
        toast.dismiss(t.id);
    };

    return (
        <ReactToaster
            toastOptions={{
                position: 'top-right',
                className: '',
                style: {},
                success: {
                    style: {
                        background: 'none',
                        border: 'none',
                        padding: '0',
                        margin: '120px 0 0 0',
                        boxShadow: 'none',
                        cursor: 'pointer',
                    },
                },
                error: {
                    style: {
                        background: 'none',
                        border: 'none',
                        padding: '0',
                        margin: '120px 0 0 0',
                        boxShadow: 'none',
                        cursor: 'pointer',
                    },
                },
                loading: {
                    style: {
                        background: 'none',
                        border: 'none',
                        padding: '0',
                        margin: '120px 0 0 0',
                        boxShadow: 'none',
                        cursor: 'pointer',
                    },
                },
            }}
        >
            {(t) => {
                let borderColor = 'border-gray-400';
                switch (t.type) {
                    case 'success':
                        borderColor = 'border-toaster-success';
                        break;
                    case 'error':
                        borderColor = 'border-toaster-error';
                        break;
                    case 'loading':
                        borderColor = 'border-primary-loading';
                        break;
                }

                let icon = <Check size={24} />;
                switch (t.type) {
                    case 'success':
                        icon = <Check size={24} />;
                        break;
                    case 'error':
                        icon = <Warning size={24} />;
                        break;
                    case 'loading':
                        icon = (
                            <CircleNotch size={24}>
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 0 0"
                                    to="360 0 0"
                                    dur="1s"
                                    repeatCount="indefinite"
                                />
                            </CircleNotch>
                        );
                        break;
                }

                return (
                    <ToastBar toast={t}>
                        {({ message }) => (
                            <>
                                <span
                                    onClick={() => dismissToast(t)}
                                    className={`d-block p-6 bg-toaster-background text-toaster-text border-l-4 ${borderColor} shadow-md rounded-r-lg`}
                                >
                                    <span className="flex items-center">
                                        <span className="inline-block mr-2">{icon}</span>
                                        <span className="font-medium d-block">{message}</span>
                                    </span>
                                </span>
                            </>
                        )}
                    </ToastBar>
                );
            }}
        </ReactToaster>
    );
}

export default Toaster;
